import React from 'react';
import ToggleButton from 'react-toggle-button';

const Toggle = props => {
  const { value, onChange } = props;

  return (
    <>
      <ToggleButton
        value={value}
        onToggle={() => onChange()}
        colors={{
          active: {
            base: '#166a96',
            hover: '#166a96',
          },
          inactive: {
            base: 'rgb(65,66,68)',
            hover: 'rgb(95,96,98)',
          },
        }}
      />
    </>
  );
};

export default Toggle;
